// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pinned-messages-popover {
  position: absolute;
  top: 60px;
  right: 24px;
  width: 380px;
  max-height: 500px;
  background: var(--bg-floating);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.pinned-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--glass-border);
  color: var(--text-primary);
}

.pinned-header h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

.pinned-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pinned-empty {
  padding: 32px 16px;
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
  font-weight: 500;
}

.pinned-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.pinned-item:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
}

.pinned-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.pinned-author {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pinned-avatar, .pinned-avatar-placeholder {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.pinned-avatar-placeholder {
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--brand-light);
}

.pinned-author-name {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

.pinned-time {
  font-size: 12px;
  color: var(--text-muted);
}

.pinned-content {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 32px;
}

.pinned-actions {
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s;
}

.pinned-item:hover .pinned-actions {
  opacity: 1;
}

.pinned-btn-go, .pinned-btn-remove {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.pinned-btn-go {
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
}

.pinned-btn-remove {
  width: 24px;
  height: 24px;
}

.pinned-btn-go:hover {
  background: var(--brand-primary);
}

.pinned-btn-remove:hover {
  background: #ef4444;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHeader/PinnedMessages.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".pinned-messages-popover {\n  position: absolute;\n  top: 60px;\n  right: 24px;\n  width: 380px;\n  max-height: 500px;\n  background: var(--bg-floating);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.pinned-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px;\n  border-bottom: 1px solid var(--glass-border);\n  color: var(--text-primary);\n}\n\n.pinned-header h3 {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.pinned-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pinned-empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.pinned-item {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.pinned-item:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.pinned-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.pinned-author {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pinned-avatar, .pinned-avatar-placeholder {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.pinned-avatar-placeholder {\n  background: var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--brand-light);\n}\n\n.pinned-author-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.pinned-time {\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.pinned-content {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-bottom: 32px;\n}\n\n.pinned-actions {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.pinned-item:hover .pinned-actions {\n  opacity: 1;\n}\n\n.pinned-btn-go, .pinned-btn-remove {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.pinned-btn-go {\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.pinned-btn-remove {\n  width: 24px;\n  height: 24px;\n}\n\n.pinned-btn-go:hover {\n  background: var(--brand-primary);\n}\n\n.pinned-btn-remove:hover {\n  background: #ef4444;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
